import {
  columnSettings,
  defaultColumns
} from '@/angularBridgeCode/services/PublisherService';

export default {
  widget: {
    iconClass: 'typcn typcn-group',
    title: ''
  },
  publishers: [],
  publisherReferences: {},
  checkReferencesText: '',
  columnSettings: columnSettings,
  userVisibleColumns: defaultColumns,
  status: {},
  invitesForPublisher: {},
  showNewPublisherInvites: false,
  accountSettings: {}
};
